import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType, ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

type Props = {
  size?: number | string
}

export const AuroraIndividualTherapySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors, isAuroraTheme } = useTheme() as ThemeType
  // early return to prevent crash if theme transitions from aurora to non-aurora (currently happening upon android log out)
  if (!isAuroraTheme) return null
  const { spotIllustration } = colors.icons as AuroraThemeType['colors']['icons']

  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 64 64'
      fill='none'
      testID={tID('AuroraIndividualTherapySecondaryRecIllustration')}
    >
      <Path
        d='M39.0633 45.7387C32.7358 56.4063 17.514 54.4037 8 52.4337C9.85291 51.9963 12.0478 51.2253 12.4118 49.3778C12.6409 48.2113 12.0149 47.0743 11.5474 45.9791C6.1518 33.3694 20.0745 27.5617 30.3824 30.7727C39.0617 33.4749 42.3282 40.2366 39.0633 45.7403V45.7387Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M24.5019 30.8621C33.7398 38.7376 47.5605 31.6951 55.9998 25.0901C46.0779 26.0875 51.4562 16.2157 39.81 11.3123C25.2315 5.17421 14.1956 22.0761 24.5019 30.8621Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
